module.exports = __webpack_public_path__ + "carnet_glycémique.140fc09f85dbd34883ea372379bd80d3.jpg";